import React from "react";
import Wrap from "../../../../hoc/Wrap";
import FormInputs from "../../FormInputs";
import { isObject,isSet } from "../../../../utils/commonUtils";

const FormInput = (props)=>{
    const {inputType,label,className,thHeadKey,changeHandler,gridEditProps,options} = props;
    const {formDataInEdit} = gridEditProps;
    const {validation}=formDataInEdit
    let disValue = '';
    try{
        disValue = formDataInEdit[thHeadKey];
        let attrbs = {};
        if(isObject(formDataInEdit[thHeadKey]) && isSet(formDataInEdit[thHeadKey].file_id,null)===null){
            disValue = formDataInEdit[thHeadKey].value;
            attrbs = isSet(formDataInEdit[thHeadKey].attributes,{});
        }
    }catch(e){

    }
   const headerClassname = (inputType==='Checkbox')?'form-check':'';
   const HocWrap = (inputType==='Checkbox')?'div':Wrap;
    return(
        <Wrap>
            <td>
            <HocWrap className={headerClassname}>
            <FormInputs
                options={options} 
                type={inputType}
                name={thHeadKey}
                className={(inputType!=='Checkbox')?className:''}
                changeHandler={(val)=>changeHandler(thHeadKey,val)}
                placeholder={label}
                value={disValue} />
                </HocWrap>
                <span className="text-danger m-1">{validation&&validation[thHeadKey]?validation[thHeadKey]:''}</span><br/>
            </td>
        </Wrap>
    )
}
FormInput.defaultProps = {
    className:'form-control',
}
export default FormInput;